var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowthGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46,34c-0.552,0-1-0.447-1-1V0h14v20c0,0.553-0.448,1-1,1s-1-0.447-1-1V2H47v31C47,33.553,46.552,34,46,34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59,64H45V46c0-0.553,0.448-1,1-1s1,0.447,1,1v16h10V34c0-0.553,0.448-1,1-1s1,0.447,1,1V64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38,37c-0.552,0-1-0.447-1-1V17H27v13c0,0.553-0.448,1-1,1s-1-0.447-1-1V15h14v21C39,36.553,38.552,37,38,37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39,64H25V41c0-0.553,0.448-1,1-1s1,0.447,1,1v21h10V47c0-0.553,0.448-1,1-1s1,0.447,1,1V64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,42c-0.552,0-1-0.447-1-1V26h14v6c0,0.553-0.448,1-1,1s-1-0.447-1-1v-4H7v13C7,41.553,6.552,42,6,42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,64H5V53c0-0.553,0.448-1,1-1s1,0.447,1,1v9h10V44c0-0.553,0.448-1,1-1s1,0.447,1,1V64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.001,52c-0.603,0-1.199-0.271-1.592-0.788c-0.669-0.879-0.5-2.134,0.379-2.803l22.015-16.773l18.759,9.873 L60.52,20.654c0.743-0.816,2.008-0.877,2.825-0.134c0.817,0.742,0.877,2.008,0.135,2.825L42.438,46.491L23.197,36.364 L3.212,51.591C2.85,51.866,2.424,52,2.001,52z"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_9"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthGraph);
export default __webpack_public_path__ + "static/media/growth-graph.d99a54f038f0d724b05c699e937627b4.svg";
export { ForwardRef as ReactComponent };